import type { TypedString } from 'types/TypedString';

type Props = {
  videoId: TypedString<'youtube-video-id'>;
  autoPlay: boolean | undefined;
  muted: boolean | undefined;
  showRelatedVideos: boolean | undefined;
};

export function getYoutubeVideoSrc({
  videoId,
  autoPlay,
  muted,
  showRelatedVideos,
}: Props) {
  const options = [
    'enablejsapi=1',
    autoPlay && 'autoplay=1',
    muted && 'mute=1',
    typeof window !== 'undefined' && `origin=${window.location.origin}`,
    showRelatedVideos && 'rel=1',
  ].filter(Boolean);

  return `https://www.youtube.com/embed/${videoId}?${options.join('&')}`;
}
